export function errorToString(e: unknown) {
  if (e instanceof Error) {
    return `${e.name}: ${e.message}`;
  }

  return `${e}`;
}
